import {
  DEFAULT_CASE_STATUS,
  DEFAULT_CURRENT_PAGE_NUMBER,
  DEFAULT_FETCH_PATIENTS,
  DEFAULT_PAGINATION_ROWS_PER_PAGE,
  DEFAULT_PATIENT_STATUS,
  DEFAULT_PORTAL_CASES,
  DEFAULT_SORT_BY_OPTION,
} from 'shared/constants/AppConst';
import {ACTION_TYPES} from '../../actions/patient/patient';
import {deepEqual} from 'fast-equals';

const initialState = {
  data: {
    currentPatient: {},
    list: {
      totalRecords: 0,
      pageNumber: 0,
      pageSize: 0,
      data: undefined,
      message: null,
    },
  },
  ui: {
    inPatientView: false,
  },
  sortBy: DEFAULT_SORT_BY_OPTION,
  caseStatus: DEFAULT_CASE_STATUS,
  patientStatus: DEFAULT_PATIENT_STATUS,
  fetchPatients: DEFAULT_FETCH_PATIENTS,
  currentPageNumber: DEFAULT_CURRENT_PAGE_NUMBER,
  rowPerPage: DEFAULT_PAGINATION_ROWS_PER_PAGE,
  portalStatuses: DEFAULT_PORTAL_CASES,
};

export const patient = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_ALL:
      return {
        ...state,
        data: {...state.data, list: {...action.payload}},
      };
    case ACTION_TYPES.FETCH_FILTERED: {
      return {
        ...state,
        data: {...state.data, list: {...action.payload}},
      };
    }

    case ACTION_TYPES.FETCH_BY_ID:
      return {
        ...state,
        data: {...state.data, currentPatient: action.payload},
      };
    case ACTION_TYPES.SET_IN_PATIENT_VIEW:
      return {...state, ui: {...state.ui, inPatientView: action.payload}};

    case ACTION_TYPES.SET_CASE_STATUS:
      return {
        ...state,
        caseStatus: action.payload,
      };

    case ACTION_TYPES.SET_PATIENT_STATUS:
      return {
        ...state,
        patientStatus: action.payload,
      };

    case ACTION_TYPES.SET_FETCH_PATIENTS:
      return {
        ...state,
        fetchPatients: action.payload,
      };

    case ACTION_TYPES.SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };

    case ACTION_TYPES.SET_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case ACTION_TYPES.SET_ROW_PER_PAGE:
      return {
        ...state,
        rowPerPage: action.payload,
      };
    case ACTION_TYPES.START_PATIENT_LOADING:
      return {
        ...state,
        patientLoader: true,
      };
    case ACTION_TYPES.STOP_PATIENT_LOADING:
      return {
        ...state,
        patientLoader: false,
      };

    case ACTION_TYPES.SET_PORTAL_STATUSES: {
      if (deepEqual(state.portalStatuses, action.payload)) {
        return state;
      } else {
        return {
          ...state,
          portalStatuses: action.payload,
        };
      }
    }

    default:
      return state;
  }
};

export const selectPatients = (state) => state.patient.data.list;
export const selectCurrentPatient = (state) =>
  state.patient.data.currentPatient;
export const selectCurrentPatientNevroCases = (state) =>
  state.patient.data.currentPatient.nevroCases;
export const selectInPatientView = (state) => state.patient.ui.inPatientView;
export const selectSortBy = (state) => state.patient.sortBy;
export const selectCaseStatus = (state) => state.patient.caseStatus;
export const selectPatientStatus = (state) => state.patient.patientStatus;
export const selectFetchPatients = (state) => state.patient.fetchPatients;
export const selectCurrentPageNumber = (state) =>
  state.patient.currentPageNumber;
export const selectRowPerPage = (state) => state.patient.rowPerPage;
export const selectPatientLoader = (state) => state.patient.patientLoader;
export const selectPortalStatuses = (state) => state.patient.portalStatuses;
